import { Ace as AceNamespace } from 'ace-builds';
import styled from 'styled-components';
import { AceEditor } from 'modules/aceEditor';
import { FormField } from 'ui/formField';
import { spacing } from 'ui/theme';
import { useJsonEditorContext } from '../context/JsonEditorContext';
import { useDbConfigContext } from '../context/DbConfigContext';

export const EditorContainer = styled.div`
  border-radius: ${spacing.quarter};
  overflow: hidden;
`;

export const JsonEditor = () => {
  const { json, jsonIsDirty, jsonIsValid, name, setJson, setJsonIsValid } = useDbConfigContext();
  const { aceEditorTheme, editor } = useJsonEditorContext();

  const onLoad = (editorInstance: AceNamespace.Editor) => {
    editor.current = editorInstance;
  };

  return (
    <FormField
      labelText="Config JSON"
      isHorizontalLayout={true}
      warningText="JSON has been changed. Update to save changes."
      hasWarning={jsonIsDirty}
      errorText="JSON is invalid."
      hasError={!jsonIsValid}
    >
      <EditorContainer>
        <AceEditor
          fontSize={14}
          height={`500px`}
          mode={'json'}
          name={'db-config'}
          onChange={setJson}
          onLoad={onLoad}
          onValidate={(errs) => setJsonIsValid(!errs.length)}
          placeholder={'enter configuration JSON here'}
          readOnly={!name}
          showPrintMargin={false}
          theme={aceEditorTheme}
          value={json}
          width={'100%'} // allows wrap to adjust to change
          wrapEnabled={true}
        />
      </EditorContainer>
    </FormField>
  );
};

export default JsonEditor;
